/**
 * Meta Pixel event helpers.
 *
 * The base Pixel script is injected in /public/index.html and exposes window.fbq.
 * These helpers wrap the canonical events we care about for the Pivotbox funnel:
 *
 *   trackViewContent({ name, value })   — visitor sees the offer (e.g. on /find-out)
 *   trackLead({ value, currency })      — visitor submits the lead-capture dialog
 *   trackInitiateCheckout({ value })    — Razorpay modal opens
 *   trackPurchase({ value, currency, transactionId, email, phone, name })
 *                                       — payment verified successfully
 *
 * Also fires a route-change PageView so SPA navigations are counted.
 */
function safeFbq(...args) {
  if (typeof window === "undefined") return;
  if (typeof window.fbq !== "function") return; // pixel not loaded / blocked
  try {
    window.fbq(...args);
  } catch (e) {
    /* swallow — analytics must never break the app */
  }
}

export function trackPageView(pathname) {
  safeFbq("track", "PageView", { page_path: pathname });
}

export function trackViewContent({ name = "full_diagnostic", value = 3999, currency = "INR" } = {}) {
  safeFbq("track", "ViewContent", {
    content_name: name,
    content_type: "product",
    value,
    currency,
  });
}

export function trackLead({ value = 3999, currency = "INR", contentName = "full_diagnostic" } = {}) {
  safeFbq("track", "Lead", {
    content_name: contentName,
    value,
    currency,
  });
}

export function trackInitiateCheckout({ value = 3999, currency = "INR", contentName = "full_diagnostic" } = {}) {
  safeFbq("track", "InitiateCheckout", {
    content_name: contentName,
    value,
    currency,
    num_items: 1,
  });
}

export function trackPurchase({ value = 3999, currency = "INR", transactionId, contentName = "full_diagnostic" } = {}) {
  safeFbq("track", "Purchase", {
    content_name: contentName,
    value,
    currency,
    num_items: 1,
    ...(transactionId ? { transaction_id: transactionId } : {}),
  });
}

export function trackInitiateAssessment() {
  // Fired when a visitor clicks any "Take the Founder Signal Test" CTA
  // (S0 assessment entry point). Spec'd by user as fbq('track', ...).
  safeFbq("track", "InitiateAssessment");
}

export function trackCompleteRegistration() {
  // Fired when the visitor submits the S0 name + mobile form, just before
  // the report/PDF is generated.
  safeFbq("track", "CompleteRegistration");
}

export function trackLeadS0() {
  // Fired when the visitor lands on /s0-report/:id (S0 assessment complete).
  // Wrapper around the standard Pixel Lead event with no params, per spec.
  safeFbq("track", "Lead");
}
